export const BYTES_PER_GIB = 1024 ** 3

export const bytesToGiB = (bytes: number) => bytes / BYTES_PER_GIB
